import { useNavigate } from "react-router-dom";

import { DashLayout, Title } from "@features/ui";

import { useRequestResetPasswordToken } from "./api/use-send-reset-password-email";
import { ForgotPasswordForm } from "./components/forgot-password.form";
import { ForgotPasswordInstructions } from "./components/forgot-password.instructions";

import "./index.scss";

export const ForgotPasswordPage = () => {
  const navigate = useNavigate();

  const {
    mutateAsync: sendResetPasswordEmail,
    isPending,
    isSuccess: formSubmittedSuccesfully,
    error,
  } = useRequestResetPasswordToken();

  const onResetPassword = async (e, email) => {
    e.preventDefault();
    await sendResetPasswordEmail(email);
  };

  const onCancel = () => {
    navigate("/login", { replace: true });
  };

  return (
    <DashLayout className="forgot-password-page">
      <div className="tx-container">
        <Title>Forgot Password</Title>
        <ForgotPasswordInstructions formSubmitted={formSubmittedSuccesfully} />
      </div>
      {!formSubmittedSuccesfully && (
        <ForgotPasswordForm
          onResetPassword={onResetPassword}
          onCancel={onCancel}
          error={error}
          loading={isPending}
        />
      )}
    </DashLayout>
  );
};
